// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e78027b4","425":"96983534","473":"1ffa7396","741":"be7dd582","774":"253ec03b","787":"6885044f","883":"2614f62a","943":"1c357e87"}[chunkId] + ".chunk.js";
};